export default __webpack_public_path__ + "locales/el-GR/InviteDialog.json?hash=d0a3670a0b6a00032e9c8503cbe0034e";